import React, { useEffect, useState } from 'react'
import FormOdooAccount from './FormAccount'
import { useNavigate } from 'react-router-dom';
import ModalBox from '../../ui/ModalBox';
import { Typography } from '@mui/material';
import { useOdooInvoices } from './provider';

const EditOdooAccount = ({account}) => {
  const [open, setOpen] = useState(false);
  const {state:{selectedAccount}} = useOdooInvoices()
  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
    navigate(-1);
  };

  const handleSuccess = () => {
    setOpen(true);
  };
  return (
    <div>
       <Typography variant="Poster" component="h4" gutterBottom
      >
        Edit Account
      </Typography>
      <FormOdooAccount account={selectedAccount} handleSuccess={handleSuccess} />
      <ModalBox
        open={open}
        handleClose={handleClose}
        text="The update operation has been completed successfully.. You updated account"
        name="Odoo Account"
      />
    </div>
  )
}

export default EditOdooAccount